import { TooltipTrigger } from "@visiblethread/react-components";
import { node, number, string } from "prop-types";
import React from "react";

import styles from "./BarTrackWrapper.module.scss";

const BarTrackWrapper = ({ children, tooltipContent, tooltipDelay = 300, tooltipMaxWidth = "none" }) => (
  <div className={styles.barTrackWrapper}>
    {tooltipContent ? (
      <TooltipTrigger content={tooltipContent} delay={tooltipDelay} maxWidth={tooltipMaxWidth}>
        {children}
      </TooltipTrigger>
    ) : (
      children
    )}
  </div>
);

BarTrackWrapper.propTypes = {
  children: node.isRequired,
  tooltipContent: node,
  tooltipDelay: number,
  tooltipMaxWidth: string,
};

export default BarTrackWrapper;
